import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import PropTypes from "prop-types"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import { isEmpty } from "lodash"
import { Col, Container, Row } from "reactstrap"

//Import sections
import AdminList from "./AdminList"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"

const AdminView = props => {
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Manage Admins | {process.env.REACT_APP_TITLE}</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Admins" breadcrumbItem="Manage Admins" />
          <Row>
            <Col lg="12">
              <AdminList />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

AdminView.propTypes = {
  match: PropTypes.object,
}

export default withRouter(AdminView)
